// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* buttons */
/* polyphil for outlines */
.btn:focus, .btn:active:focus, .btn.active:focus {
  outline: none;
}

/* primary button */
.btn {
  font-family: "Open Sans";
  font-size: 14px;
  border-radius: 3px;
  text-decoration: none;
  box-sizing: border-box;
  min-width: 110px;
  height: 40px;
}
.btn:focus {
  outline: 0 !important;
  box-shadow: none;
}

.btn.btn-primary {
  color: #fff;
  background-color: #007cbe;
  border-color: #007cbe;
  box-shadow: 0px 2px 0px 0px #1c639c;
}

.btn.btn-primary:hover, .btn-primary:focus:hover:not(:active) {
  background-color: #298fd8;
  border-color: #298fd8;
  box-shadow: 0px 2px 0px 0px #237cbb;
}

.btn.btn-primary:focus {
  background-color: #007cbe;
  border-color: #007cbe;
  box-shadow: 0px 2px 0px 0px #1c639c;
}

.btn.btn-primary:active {
  background-color: #006398;
  border-color: #006398;
  box-shadow: none; /* 0px 2px 0px 0px #006398;*/
}

/* secondary button */
.btn.btn-secondary {
  color: #6b7984;
  background-color: #fff;
  border-color: #dae2e8;
  box-shadow: 0px 2px 0px 0px #dae2e8;
}

.btn.btn-secondary:hover, .btn-secondary:hover:focus:not(:active) {
  background-color: #fff;
  border-color: #6b8ea8;
  box-shadow: 0px 2px 0px 0px #6b8ea8;
}

.btn.btn-secondary:focus {
  background-color: #fff;
  border-color: #dae2e8;
  box-shadow: 0px 2px 0px 0px #dae2e8;
}

.btn.btn-secondary:active {
  background-color: #ecf2f6;
  border-color: #afc1cf;
  box-shadow: none;
}

/* disabled buttons */
.btn.disabled,
.btn.disabled:hover,
.btn[disabled]:hover,
.btn.disabled:focus,
.btn[disabled]:focus,
.btn.disabled:active,
.btn[disabled]:active,
.btn.disabled.active,
.btn[disabled].active {
  background-color: #eeeeee !important;
  border-color: #dde4e9 !important;
  color: #697782 !important;
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  box-shadow: 0px 2px 0px 0px #dae2e8 !important;
  cursor: default;
}

/* red button */
.btn.btn-red {
  color: #fff;
  background-color: #D44646;
  border-color: #AA3232;
  box-shadow: 0px 2px 0px 0px #c84f4f;
}

.btn.btn-red:hover, .btn-red:hover:focus:not(:active) {
  background-color: #f96c6c;
  border-color: #fa4549;
  box-shadow: 0px 2px 0px 0px #c95555;
}

.btn.btn-red:focus {
  background-color: #D44646;
  border-color: #AA3232;
  box-shadow: 0px 2px 0px 0px #c84f4f;
}

.btn.btn-red:active {
  background-color: #c11a1a;
  border-color: #c11a1a;
  box-shadow: none;
}

/* buttons sizes */
.btn.btn-lg {
  padding: 8px 25px 6px;
  line-height: 24px;
  margin: 0 10px;
}

.btn.btn-sm {
  padding: 8px 25px 6px;
  font-size: 14px;
  line-height: 14px;
  margin: 0 6px;
}

.btn.btn-xs {
  padding: 4px 15px 2px;
  font-size: 11px;
  line-height: 10px;
  margin: 0 4px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/breeze-button/breeze-button.component.scss","webpack://./../PSR%20ESP%20WebApp%20Build/src/app/components/breeze-button/breeze-button.component.scss"],"names":[],"mappings":"AAAA,YAAA;AAEA,0BAAA;AACA;EACE,aAAA;ACAF;;ADGA,mBAAA;AACA;EACE,wBAAA;EACA,eAAA;EACA,kBAAA;EACA,qBAAA;EACA,sBAAA;EACA,gBAAA;EACA,YAAA;ACAF;ADEE;EACE,qBAAA;EACA,gBAAA;ACAJ;;ADIA;EACE,WAAA;EACA,yBAAA;EACA,qBAAA;EACA,mCAAA;ACDF;;ADIA;EACE,yBAAA;EACA,qBAAA;EACA,mCAAA;ACDF;;ADIA;EACE,yBAAA;EACA,qBAAA;EACA,mCAAA;ACDF;;ADIA;EACE,yBAAA;EACA,qBAAA;EACA,gBAAA,EAAA,4BAAA;ACDF;;ADIA,qBAAA;AACA;EACE,cAAA;EACA,sBAAA;EACA,qBAAA;EACA,mCAAA;ACDF;;ADIA;EACE,sBAAA;EACA,qBAAA;EACA,mCAAA;ACDF;;ADIA;EACE,sBAAA;EACA,qBAAA;EACA,mCAAA;ACDF;;ADIA;EACE,yBAAA;EACA,qBAAA;EACA,gBAAA;ACDF;;ADIA,qBAAA;AACA;;;;;;;;;EASE,oCAAA;EACA,gCAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,8CAAA;EACA,eAAA;ACDF;;ADIA,eAAA;AACA;EACE,WAAA;EACA,yBAAA;EACA,qBAAA;EACA,mCAAA;ACDF;;ADIA;EACE,yBAAA;EACA,qBAAA;EACA,mCAAA;ACDF;;ADIA;EACE,yBAAA;EACA,qBAAA;EACA,mCAAA;ACDF;;ADIA;EACE,yBAAA;EACA,qBAAA;EACA,gBAAA;ACDF;;ADKA,kBAAA;AACA;EACE,qBAAA;EACA,iBAAA;EACA,cAAA;ACFF;;ADKA;EACE,qBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;ACFF;;ADKA;EACE,qBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;ACFF","sourcesContent":["/* buttons */\n\n/* polyphil for outlines */\n.btn:focus, .btn:active:focus, .btn.active:focus {\n  outline: none;\n}\n\n/* primary button */\n.btn {\n  font-family: \"Open Sans\";\n  font-size: 14px;\n  border-radius: 3px;\n  text-decoration: none;\n  box-sizing: border-box;\n  min-width: 110px;\n  height: 40px;\n\n  &:focus {\n    outline: 0 !important;\n    box-shadow: none;\n  }\n}\n\n.btn.btn-primary {\n  color: #fff;\n  background-color: #007cbe;\n  border-color: #007cbe;\n  box-shadow: 0px 2px 0px 0px #1c639c;\n}\n\n.btn.btn-primary:hover, .btn-primary:focus:hover:not(:active) {\n  background-color: #298fd8;\n  border-color: #298fd8;\n  box-shadow: 0px 2px 0px 0px #237cbb;\n}\n\n.btn.btn-primary:focus {\n  background-color: #007cbe;\n  border-color: #007cbe;\n  box-shadow: 0px 2px 0px 0px #1c639c;\n}\n\n.btn.btn-primary:active {\n  background-color: #006398;\n  border-color: #006398;\n  box-shadow: none; /* 0px 2px 0px 0px #006398;*/\n}\n\n/* secondary button */\n.btn.btn-secondary {\n  color: #6b7984;\n  background-color: #fff;\n  border-color: #dae2e8;\n  box-shadow: 0px 2px 0px 0px #dae2e8;\n}\n\n.btn.btn-secondary:hover, .btn-secondary:hover:focus:not(:active) {\n  background-color: #fff;\n  border-color: #6b8ea8;\n  box-shadow: 0px 2px 0px 0px #6b8ea8;\n}\n\n.btn.btn-secondary:focus {\n  background-color: #fff;\n  border-color: #dae2e8;\n  box-shadow: 0px 2px 0px 0px #dae2e8;\n}\n\n.btn.btn-secondary:active {\n  background-color: #ecf2f6;\n  border-color: #afc1cf;\n  box-shadow: none;\n}\n\n/* disabled buttons */\n.btn.disabled,\n.btn.disabled:hover,\n.btn[disabled]:hover,\n.btn.disabled:focus,\n.btn[disabled]:focus,\n.btn.disabled:active,\n.btn[disabled]:active,\n.btn.disabled.active,\n.btn[disabled].active {\n  background-color: #eeeeee !important;\n  border-color: #dde4e9 !important;\n  color: #697782 !important;\n  font-size: 14px;\n  font-weight: 600;\n  text-align: center;\n  box-shadow: 0px 2px 0px 0px #dae2e8 !important;\n  cursor: default;\n}\n\n/* red button */\n.btn.btn-red {\n  color: #fff;\n  background-color: #D44646;\n  border-color: #AA3232;\n  box-shadow: 0px 2px 0px 0px #c84f4f;\n}\n\n.btn.btn-red:hover, .btn-red:hover:focus:not(:active) {\n  background-color: #f96c6c;\n  border-color: #fa4549;\n  box-shadow: 0px 2px 0px 0px #c95555;\n}\n\n.btn.btn-red:focus {\n  background-color: #D44646;\n  border-color: #AA3232;\n  box-shadow: 0px 2px 0px 0px #c84f4f;\n}\n\n.btn.btn-red:active {\n  background-color: #c11a1a;\n  border-color: #c11a1a;\n  box-shadow: none;\n}\n\n\n/* buttons sizes */\n.btn.btn-lg {\n  padding: 8px 25px 6px;\n  line-height: 24px;\n  margin: 0 10px;\n}\n\n.btn.btn-sm {\n  padding: 8px 25px 6px;\n  font-size: 14px;\n  line-height: 14px;\n  margin: 0 6px;\n}\n\n.btn.btn-xs {\n  padding: 4px 15px 2px;\n  font-size: 11px;\n  line-height: 10px;\n  margin: 0 4px;\n}\n","/* buttons */\n/* polyphil for outlines */\n.btn:focus, .btn:active:focus, .btn.active:focus {\n  outline: none;\n}\n\n/* primary button */\n.btn {\n  font-family: \"Open Sans\";\n  font-size: 14px;\n  border-radius: 3px;\n  text-decoration: none;\n  box-sizing: border-box;\n  min-width: 110px;\n  height: 40px;\n}\n.btn:focus {\n  outline: 0 !important;\n  box-shadow: none;\n}\n\n.btn.btn-primary {\n  color: #fff;\n  background-color: #007cbe;\n  border-color: #007cbe;\n  box-shadow: 0px 2px 0px 0px #1c639c;\n}\n\n.btn.btn-primary:hover, .btn-primary:focus:hover:not(:active) {\n  background-color: #298fd8;\n  border-color: #298fd8;\n  box-shadow: 0px 2px 0px 0px #237cbb;\n}\n\n.btn.btn-primary:focus {\n  background-color: #007cbe;\n  border-color: #007cbe;\n  box-shadow: 0px 2px 0px 0px #1c639c;\n}\n\n.btn.btn-primary:active {\n  background-color: #006398;\n  border-color: #006398;\n  box-shadow: none; /* 0px 2px 0px 0px #006398;*/\n}\n\n/* secondary button */\n.btn.btn-secondary {\n  color: #6b7984;\n  background-color: #fff;\n  border-color: #dae2e8;\n  box-shadow: 0px 2px 0px 0px #dae2e8;\n}\n\n.btn.btn-secondary:hover, .btn-secondary:hover:focus:not(:active) {\n  background-color: #fff;\n  border-color: #6b8ea8;\n  box-shadow: 0px 2px 0px 0px #6b8ea8;\n}\n\n.btn.btn-secondary:focus {\n  background-color: #fff;\n  border-color: #dae2e8;\n  box-shadow: 0px 2px 0px 0px #dae2e8;\n}\n\n.btn.btn-secondary:active {\n  background-color: #ecf2f6;\n  border-color: #afc1cf;\n  box-shadow: none;\n}\n\n/* disabled buttons */\n.btn.disabled,\n.btn.disabled:hover,\n.btn[disabled]:hover,\n.btn.disabled:focus,\n.btn[disabled]:focus,\n.btn.disabled:active,\n.btn[disabled]:active,\n.btn.disabled.active,\n.btn[disabled].active {\n  background-color: #eeeeee !important;\n  border-color: #dde4e9 !important;\n  color: #697782 !important;\n  font-size: 14px;\n  font-weight: 600;\n  text-align: center;\n  box-shadow: 0px 2px 0px 0px #dae2e8 !important;\n  cursor: default;\n}\n\n/* red button */\n.btn.btn-red {\n  color: #fff;\n  background-color: #D44646;\n  border-color: #AA3232;\n  box-shadow: 0px 2px 0px 0px #c84f4f;\n}\n\n.btn.btn-red:hover, .btn-red:hover:focus:not(:active) {\n  background-color: #f96c6c;\n  border-color: #fa4549;\n  box-shadow: 0px 2px 0px 0px #c95555;\n}\n\n.btn.btn-red:focus {\n  background-color: #D44646;\n  border-color: #AA3232;\n  box-shadow: 0px 2px 0px 0px #c84f4f;\n}\n\n.btn.btn-red:active {\n  background-color: #c11a1a;\n  border-color: #c11a1a;\n  box-shadow: none;\n}\n\n/* buttons sizes */\n.btn.btn-lg {\n  padding: 8px 25px 6px;\n  line-height: 24px;\n  margin: 0 10px;\n}\n\n.btn.btn-sm {\n  padding: 8px 25px 6px;\n  font-size: 14px;\n  line-height: 14px;\n  margin: 0 6px;\n}\n\n.btn.btn-xs {\n  padding: 4px 15px 2px;\n  font-size: 11px;\n  line-height: 10px;\n  margin: 0 4px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
